import { useEffect } from "react"; // Importing useEffect hook from React
import { Button, Loader } from "@storybook"; // Importing Button and Loader components from Storybook

import { LabelDescription } from "components/label-description"; // Importing the LabelDescription component
import { useTimer } from "hooks"; // Importing the useTimer custom hook

import "./wating-approval.scss"; // Importing the SCSS file for styling

interface IWatingApproval {
  handleBack: () => void; // Function to handle the back button click
  handleResend?: () => void; // Function to handle the resend button click
  expireTime?: number; // Optional expiration time in seconds
  label: string; // Main label text
  sublabel: string; // Sublabel text
  time_remaining: string; // Text for time remaining
  receive: string; // Text for receiving the approval
  loader?: React.ReactNode; // Status information
  styles?: React.CSSProperties; // Optional styles for the component
}

/**
 * WatingApproval component displays a waiting screen with a timer, a back button, and status information.
 *
 * @param {IWatingApproval} props - The properties object for the WatingApproval component.
 * @param {() => void} props.handleBack - Function to handle the back button click.
 * @param {() => void} props.handleResend - Function to handle the resend button click.
 * @param {number} [props.expireTime=60] - Optional expiration time in seconds.
 * @param {string} props.label - The main label text.
 * @param {string} props.sublabel - The sublabel text.
 * @param {string} props.time_remaining - Text for time remaining.
 * @param {string} props.receive - Text for receiving the approval.
 *
 * @returns {JSX.Element} The rendered WatingApproval component.
 */
export const WatingApproval = ({
  handleBack,
  handleResend,
  expireTime = 30,
  label = "",
  sublabel = "",
  // time_remaining = "",
  receive,
  loader,
  styles,
}: IWatingApproval) => {
  // Using the useTimer hook to manage the timer state
  const { seconds, setSeconds } = useTimer();

  const handleResendClick = () => {
    if (seconds === 0) {
      handleResend?.();
      setSeconds(expireTime);
    }
  };

  useEffect(() => {
    // Setting the initial timer value
    setSeconds(expireTime);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="wating-approval-wrapper">
      {/* Main container with styling */}
      <div
        className="flex direction-col gap-16 signin-methods-wrapper__card"
        style={styles}
      >
        {/* Label and Description */}
        <LabelDescription label={label} description={<div>{sublabel}</div>} />

        {/* Loader to indicate waiting state */}
        <div className="grid-center">
        {loader ? loader : <Loader dimension={70} type="loader" />}
        </div>
        <div></div> 
        {/* Back Button */}
        <Button
          label="Back"
          type="button__filled button__filled--secondary  button__block"
          handleClick={handleBack}
        />
        {/* Timer and Receive Status */}
        <LabelDescription
          description={
            <div className="text-center">
              {/* Conditionally render time remaining or receive status */}

              <div
                className="text-center  wating-approval-wrapper__footer"
                onClick={() => handleResendClick?.()}
              >
                {receive}{" "}
                <span className={`${seconds !== 0 ? "disabled" : ""}`}>
                  Resend
                </span>{" "}
                {seconds !== 0 ? `in ${seconds}s` : ""} {/* 'Resend' action */}
              </div>
              {/* {seconds !== 0 ? (
                `${time_remaining} ${seconds}s`
              ) : (
                <div className="text-center  wating-approval-wrapper__footer" onClick={()=>handleResendClick?.()}>
                  {receive} <span>Resend</span>
                </div>
              )} */}
            </div>
          }
        />
      </div>
    </div>
  );
};
